import { provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { deepFreeze, elfHooks, enableElfProdMode } from '@ngneat/elf';
import { devTools } from '@ngneat/elf-devtools';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableElfProdMode();
} else {
  devTools();
  elfHooks.registerPreStoreUpdate((_currentState, nextState) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return deepFreeze(nextState);
  });
}

platformBrowser()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  })
  .catch((err) => console.error(err));
